<template>
  <div>
    <div class="card">
      <div class="card-header card-header-flex align-items-center justify-content-end">
        <b-button
          variant="outline-primary"
          to="./auctions/create-new"
        >
          {{ $t('auction.create_new') }}
        </b-button>
      </div>
      <div class="card-body">
        <a-table
          class="product-table"
          :columns="columns"
          :data-source="data"
          :row-key="'id'"
          :pagination="pagination"
          @change="handleTableChange"
        >
          <div
            slot="filterDropdown"
            slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
            class="custom-filter-dropdown"
            style="padding: 8px"
          >
            <a-input
              :placeholder="`Search ${column.dataIndex}`"
              :value="selectedKeys[0]"
              style="width: 188px; margin-bottom: 8px; display: block;"
              @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
              @pressEnter="() => handleSearch(selectedKeys, confirm)"
            />
            <a-button
              type="primary"
              size="small"
              style="width: 90px; margin-right: 8px"
              @click="() => handleSearch(selectedKeys, confirm)"
            >
              {{ $t('common.search') }}
            </a-button>
            <a-button
              size="small"
              style="width: 90px"
              @click="() => handleReset(clearFilters)"
            >
              {{ $t('common.reset') }}
            </a-button>
          </div>
          <template
            slot="lotTitle"
            slot-scope="text"
          >
            <span
              v-b-tooltip.hover
              :title="text"
            >{{ text | shrinkString(10) }}</span>
          </template>
          <template
            slot="date"
            slot-scope="text"
          >
            {{ text | dateFormatter('YYYY-MM-DD HH:mm') }}
          </template>
          <template
            slot="currentPrice"
            slot-scope="text"
          >
            {{ text | money }}
          </template>
          <template
            slot="status"
            slot-scope="text"
          >
            <a-tag
              v-if="text === 'NEW'"
              color="blue"
            >
              {{ $t(`auction.status.${text}`) }}
            </a-tag>
            <a-tag
              v-else-if="text === 'STARTED'"
              color="cyan"
            >
              {{ $t(`auction.status.${text}`) }}
            </a-tag>
            <a-tag
              v-else-if="text === 'PAID'"
              color="green"
            >
              {{ $t(`auction.status.${text}`) }}
            </a-tag>
            <a-tag
              v-else-if="text === 'NOT_PAID'"
              color="orange"
            >
              {{ $t(`auction.status.${text}`) }}
            </a-tag>
            <a-tag
              v-else-if="text === 'FINISHED'"
              color="red"
            >
              {{ $t(`auction.status.${text}`) }}
            </a-tag>
          </template>
          <template
            slot="duration"
            slot-scope="record"
          >
            {{ differenceInDays(record.active_from, record.active_to) }}
          </template>
          <template
            slot="actions"
            slot-scope="text"
          >
            <router-link :to="`./auctions/${text}`">
              <b-button
                size="sm"
                variant="light"
                class="mr-2 mb-1"
              >
                <i class="fa fa-eye" />
              </b-button>
            </router-link>
          </template>
        </a-table>
      </div>
    </div>
  </div>
</template>
<script>
import auctionService from '@/services/api/admin/auction-service'
import dayjs from 'dayjs'
export default {
  name: 'Auctions',
  data: function () {
    return {
      data: [],
      columns: [
        {
          title: '№',
          dataIndex: 'id',
          key: 'id',
        },
        {
          title: this.$t('auction.lot_title'),
          dataIndex: 'auction_name',
          key: 'auction_name',
          scopedSlots: {
            customRender: 'lotTitle',
          },
        },
        {
          title: this.$t('auction.current_price'),
          dataIndex: 'maxBid',
          key: 'current_price',
          scopedSlots: {
            customRender: 'currentPrice',
          },
        },
        {
          title: this.$t('auction.bid_quantity'),
          dataIndex: 'bidCount',
          key: 'bid_quantity',
          width: 100,
        },
        {
          title: this.$t('auction.date_open'),
          dataIndex: 'active_from',
          key: 'date_open',
          scopedSlots: {
            customRender: 'date',
          },
        },
        {
          title: this.$t('auction.status.self'),
          dataIndex: 'status',
          key: 'status',
          filters: [
            { text: this.$t('auction.status.NEW'), value: 'NEW' },
            { text: this.$t('auction.status.STARTED'), value: 'STARTED' },
            { text: this.$t('auction.status.PAID'), value: 'PAID' },
            { text: this.$t('auction.status.NOT_PAID'), value: 'NOT_PAID' },
            { text: this.$t('auction.status.FINISHED'), value: 'FINISHED' },
          ],
          scopedSlots: {
            customRender: 'status',
          },
        },
        {
          title: this.$t('auction.duration'),
          key: 'duration',
          scopedSlots: {
            customRender: 'duration',
          },
        },
        {
          dataIndex: 'hash_id',
          key: 'actions',
          scopedSlots: {
            customRender: 'actions',
          },
        },
      ],
      pagination: {
        current: 1,
        pageSize: 30,
        total: 0,
      },
      sorting: {
        col: 'date_created',
        order: 'desc',
      },
      filters: {},
      // new user vars end
    }
  },
  computed: {

  },
  mounted () {
    this.fetchAuctions()
  },

  methods: {
    handleSearch(selectedKeys, confirm) {
      this.searchText = selectedKeys[0]
      confirm()
    },
    handleReset(clearFilters) {
      this.searchText = ''
      clearFilters()
    },
    handleTableChange (pagination, filter, sorter) {
      if (sorter.columnKey && sorter.order)
        this.sorting = {
          col: sorter.columnKey,
          order: sorter.order.replace('end', ''), // ascend -> asc | descend -> desc
        }
      Object.keys(filter).forEach(key => {
        if (filter[key] && filter[key].length > 0)
          this.filters[key] = filter[key].join(',')
        else
          this.filters[key] = null
      })

      this.pagination.current = pagination.current

      this.fetchAuctions()
    },

    fetchAuctions () {
      auctionService.getAuctions(this.pagination, this.sorting, this.filters)
        .then(({ data: { content, pagination } }) => {
          this.data = content
          this.pagination.total = pagination.total
        })
    },

    differenceInDays(active_from, active_to) {
      const duration = require('dayjs/plugin/duration')
      dayjs.extend(duration)
      const auctionDuration = dayjs(active_to).valueOf() - dayjs(active_from).valueOf()
      return dayjs.duration(auctionDuration).format(`D [${this.$t('common.days')}], H [${this.$t('common.hours')}], m [${this.$t('common.minutes')}]`)
    },
  },
}
</script>
<style scoped>
  .custom-filter-dropdown {
    padding: 8px;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }

  .highlight {
    background-color: rgb(255, 192, 105);
    padding: 0px;
  }
</style>
